import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/services/marriages.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function  Marriage(props2){


    return(
<div>
<Topheader></Topheader>
<Innerbanner title={"Maarriage and Relationship Analysis"}></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">

    <div className="bg-light shadow p-3 m-3 flex-fill"><img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid float-start m-3"></img>
   <p> 
   Marriage and relationships are integral aspects of astrology, providing guidance and insights to foster harmony and connection. Astrologers like Sanjay Bhargav offer specialized services to support individuals in their quest for a fulfilling relationship.</p>
    
<p>
<span className="fw-bolder">Matchmaking and Kundali Milan </span> Best Astrologers Gurgaon , Sanjay Bhargav  compare horoscopes of potential partners to assess compatibility. This detailed analysis includes Guna Milan, Manglik Dosha assessment, and other vital factors to ensure a harmonious match.
</p><p>
<span className="fw-bolder">Marriage Timing:</span> By analyzing planetary transits and doshas, astrologers provide guidance on auspicious times for marriage. This helps individuals plan their marriage during a period when celestial influences are favorable.
</p><p>
<span className="fw-bolder">Relationship Counseling:</span>  Astrology can provide insights into relationship dynamics, helping couples understand each other’s needs, strengths, and challenges. Astrologers can suggest remedies to strengthen the relationship and resolve conflicts.
</p><p>
<span className="fw-bolder">Remedies for Marital Issuess</span>  For those facing challenges in their marriage, astrologers can suggest remedies like specific mantras, gem recommendations, and rituals to mitigate negative planetary influences.
</p><p>Astrology is not just about predicting future events but also about understanding oneself and building stronger relationships. Regular consultations can provide ongoing support and guidance to navigate the complexities of married life.

For personalized insights and guidance, individuals can visit Astrologer Sanjay Bhargav's website or reputable online astrology platforms.

Remember, while astrology provides valuable guidance, open communication and mutual understanding remain paramount in nurturing a loving and lasting relationship.
</p>
<p className="text-center"><a href='https://api.whatsapp.com/send?phone=919873336259&text='><button className="btn btn-danger">Interested in a specific area of relationship astrology? Let me know! </button></a></p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export { Marriage} ;